import update from 'immutability-helper';
import get from 'lodash/get';

import * as DRAWER_LEADS from './actions';

const defaultState = {
    data: {
        id: null,
    },
    show: false,
    isLoadingDetails: false
};

const ACTION_HANDLERS = {

    [DRAWER_LEADS.SHOW]: (state, action) => {
        const data = get(action, 'payload.data') ? get(action, 'payload.data') : defaultState.data;
        const hasId = data && data.id;
        
        return update(state, {
            data: { $set: hasId ? { id: data.id } : data }, // Only store ID when editing existing lead
            show: { $set: true },
            isLoadingDetails: { $set: hasId } // Show skeleton immediately if we have an ID
        });
    },

    [DRAWER_LEADS.CLOSE]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
            isLoadingDetails: { $set: false }
        })
    },

    [DRAWER_LEADS.SAVE.SUCCESS]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    [DRAWER_LEADS.DELETE.SUCCESS]: (state) => {
        return update(state, {
            data: { $set: defaultState.data} ,
            show: { $set: false },
        })
    },

    [DRAWER_LEADS.FETCH_LEAD_DETAILS.INIT]: (state) => {
        // Don't set isLoadingDetails to true if already true to prevent duplicate calls
        return state.isLoadingDetails ? state : update(state, {
            isLoadingDetails: { $set: true }
        })
    },

    [DRAWER_LEADS.FETCH_LEAD_DETAILS.SUCCESS]: (state, action) => {
        return update(state, {
            data: { $set: get(action, 'payload.data.data') || defaultState.data },
            isLoadingDetails: { $set: false }
        })
    },

    [DRAWER_LEADS.FETCH_LEAD_DETAILS.FAILURE]: (state) => {
        return update(state, {
            isLoadingDetails: { $set: false }
        })
    },

    [DRAWER_LEADS.CREATE_DASHTASK.SUCCESS]: (state, action) => {
        return update(state, {
            data: { $set: get(action, 'payload.data.data') || state.data }
        })
    },
}

const reducer = (state = defaultState, action) => {
    const handler = ACTION_HANDLERS[action.type];
  
    return handler ? handler(state, action) : state;
};

export default reducer;